import { injectable } from 'inversify';
import { action, observable } from 'mobx';

import type { SendOrderMessageResponse } from '~gateways/ownable.dtos';
import UserAPI from '~gateways/user-api';
import type { OrderHistory } from '~types/models-types';

@injectable()
class OrderHistoryStore {
  @observable uiOrderHistoryPanelOpen: boolean = false;
  @observable uiSearchTerm: string = '';
  @observable orderHistory: OrderHistory[] = [];
  @observable orderQuestionResponse: SendOrderMessageResponse | undefined =
    undefined;

  @action setOrderQuestionResponse = (
    newState: SendOrderMessageResponse | undefined = undefined
  ) => {
    this.orderQuestionResponse = newState;
  };

  @action
  initOrderHistory = async () => {
    this.setUiOrderHistoryPanelOpen(true);
    this.orderHistory = await this.getUserOrderHistory();
  };

  @action
  getUserOrderHistory = async () => {
    const response = await UserAPI.getOrderHistory(this.uiSearchTerm);
    return response?.orders ?? [];
  };

  @action
  cancelOrder = async (id: number) => {
    const response = await UserAPI.cancelOrderInHistory(id);

    if (response?.success) {
      this.orderHistory = this.orderHistory.map((order) =>
        order.id === response.order.id ? response.order : order
      );
    }
    return response;
  };

  @action
  setUiOrderHistoryPanelOpen = (
    newState: boolean = !this.uiOrderHistoryPanelOpen
  ) => {
    this.uiOrderHistoryPanelOpen = newState;
  };
}

export default OrderHistoryStore;
